import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { IItemForGetShortInfo, IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { TCreateTeaserSelectedItem } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useEffect, useMemo } from 'react';
import { getCategoriesShortInfo } from 'backend/categories';
import { useTranslation } from 'react-i18next';

interface IDishCategorySelect {
	selectedRestaurants: string[];
	setTransitionDishCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishCategories: (value: IItemForGetShortInfo[]) => void;
}

const DishCategorySelect: React.FC<IDishCategorySelect> = ({
	selectedRestaurants,
	setTransitionDishCategory,
	setFetchedDishCategories,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(selectedRestaurants.length ? getCategoriesShortInfo : null, {
		restaurantIds: selectedRestaurants,
	});
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	useEffect(() => {
		refetch();
	}, [selectedRestaurants]);

	useEffect(() => {
		response && setFetchedDishCategories(response.data.categories);
	}, [response]);

	return (
		<FormSelect
			testId="DishCategorySelect"
			name="selectedTransitionDishCategory"
			label="categoryLabel"
			disabled={!selectedRestaurants.length || loading}
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setTransitionDishCategory}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DishCategorySelect);
